import { useMemo } from "react";
import { NotesList } from "@/features/notes/components/Notes/NotesList";
import { useNotesTrashActions } from "@/features/notes/hooks/useNotesTrashActions";
import { useNotesTrashHandlers } from "@/features/notes/hooks/useNotesTrashHandlers";
import { useNotesTrashState } from "@/features/notes/hooks/useNotesTrashState";
import { NotesTrashPlaceholders } from "@/features/notes/components/NotesTrash/NotesTrashPlaceholders";
import { NotesTrashSelectionToolbar } from "@/features/notes/components/NotesTrash/NotesTrashSelectionToolbar";
import { usePageLayout } from "@/app/hooks/usePageLayout";

export function NotesTrashRoute() {
  const {
    // State
    selectedNotes,
    setSelectedNotes,
    isSelectionMode,
    setIsSelectionMode,

    // Store data
    deletedNotes,
    deleteNote,
    restoreNote,

    // Handlers
    clearSelection,
    handleRestoreSelected,
    handleDeleteSelected,
  } = useNotesTrashState();

  const { layoutScrollTop, handlePress } = useNotesTrashHandlers({
    setSelectedNotes,
    isSelectionMode,
    setIsSelectionMode,
  });

  const actions = useNotesTrashActions({ deleteNote, restoreNote });

  // Early returns for loading and error states
  const placeholderComponent = <NotesTrashPlaceholders deletedNotes={deletedNotes} />;

  const pageLayoutConfig = useMemo(
    () => ({
      navbar: {
        actions: isSelectionMode
          ? NotesTrashSelectionToolbar({
              selectedNotesCount: selectedNotes.size,
              onRestoreSelected: handleRestoreSelected,
              onDeleteSelected: handleDeleteSelected,
              onClearSelection: clearSelection,
            })
          : [],
        title: isSelectionMode ? `${selectedNotes.size} selected` : "Trash",
      },
      ref: layoutScrollTop,
    }),
    [isSelectionMode, selectedNotes.size, handleRestoreSelected, handleDeleteSelected, clearSelection, layoutScrollTop]
  );
  usePageLayout(pageLayoutConfig);

  if (!deletedNotes || !deletedNotes.length) {
    return placeholderComponent;
  }

  return (
    <NotesList
      actions={actions}
      notes={deletedNotes}
      onPress={handlePress}
      selectedNotes={selectedNotes}
      isSelectionMode={isSelectionMode}
    />
  );
}
